import React, { FC, useState } from 'react';
import { useParams } from 'react-router';
import { Box } from '@mui/system';
import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';
import { TabLayout } from '@im/ui-lib/TabLayout';
import { isEmbedded } from 'src/util';
import {
  useGetProductGroups,
  useProductGroupQueryParams,
} from '../hooks/useProductGroups';
import Products from './Products/Products';
import CustomerGroupDetailsInfo from 'src/views/customerGroups/CustomerGroupDetails/CustomerGroupDetailsInfo';

export interface RouteParams {
  id: string;
}

const ProductGroupDetails: FC = () => {
  const { id } = useParams<keyof RouteParams>() as RouteParams;
  const [currentTab, setCurrentTab] = useState(0);
  const { searchQuery } = useProductGroupQueryParams({
    filter: {
      field: 'id',
      value: id,
    },
    page: 1,
    pageSize: 1,
  });
  const { data, isLoading } = useGetProductGroups(searchQuery);

  const productGroup = data?.data[0];

  const skeleton = (
    <Stack spacing={2}>
      <Skeleton data-testid="Skeleton" height={60} variant="rectangular" />
      <Skeleton height={300} variant="rectangular" />
    </Stack>
  );

  return (
    <Box px={isEmbedded() ? 2 : { sm: 3, xs: 1 }} py={2}>
      {isLoading
        ? skeleton
        : productGroup && (
            <>
              <CustomerGroupDetailsInfo
                customerGroup={{
                  createdAt: productGroup.created,
                  customerCount: productGroup.productcount,
                  description: productGroup.description,
                  id: productGroup.id.toString(),
                  lastUpdated: productGroup.lastupdated,
                  name: productGroup.name,
                  status: productGroup.status,
                  vendorProgramCount: 0,
                }}
                isProductGroups={true}
              />
              <TabLayout
                onTabChange={setCurrentTab}
                selectedTab={currentTab}
                sx={{
                  '& > .MuiBox-root': {
                    border: 'none',
                  },
                }}
                tabsData={[
                  {
                    tabContent: <Products productGroup={productGroup} />,
                    tabCount: productGroup.productcount.toString(),
                    tabTitle: 'ProductGroups.Products',
                  },
                ]}
              />
            </>
          )}
    </Box>
  );
};

export default ProductGroupDetails;
